import React, { FC } from 'react';

import { fc } from 'i18n';
import { Controls } from './controls';
import { TableFooter } from './footer';
import { StickyTable } from 'components/organisms/sticky-table';
import { useOfficersNotifications } from 'hooks/tep/officers-notifications/useOfficersNotifications';

import styles from './styles.module.css';

export const TepOfficersNotifications: FC = () => {
  const { controlProps, tableProps, footerProps } = useOfficersNotifications();

  return (
    <div className={styles.wrapper} style={{ height: `${window.innerHeight - 70}px` }}>
      <div className={styles.card}>
        <div className={styles.header}>{fc('Enforcement Officers Notifications')}</div>
        <Controls {...controlProps} />
        <StickyTable {...tableProps} />
        {!!tableProps.data?.length && <TableFooter {...footerProps} />}
      </div>
    </div>
  );
};
